/**
 * haptics.ts — Capacitor haptic feedback utility.
 *
 * Wraps @capacitor/haptics behind a native-platform guard.
 * No-ops silently on web to keep call sites clean.
 */

import { Capacitor } from "@capacitor/core"
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics"

function isNative(): boolean {
  return Capacitor.isNativePlatform()
}

/** Light tap — drag pickup, checkbox toggle, drag-over zone entry */
export function hapticLight(): void {
  if (isNative()) {
    Haptics.impact({ style: ImpactStyle.Light }).catch(() => {})
  }
}

/** Medium tap — drop confirm */
export function hapticMedium(): void {
  if (isNative()) {
    Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {})
  }
}

/** Heavy tap — reserved for emphasis */
export function hapticHeavy(): void {
  if (isNative()) {
    Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {})
  }
}

/** Warning notification — destructive swipe (delete) */
export function hapticWarning(): void {
  if (isNative()) {
    Haptics.notification({ type: NotificationType.Warning }).catch(() => {})
  }
}

/** Error notification */
export function hapticError(): void {
  if (isNative()) {
    Haptics.notification({ type: NotificationType.Error }).catch(() => {})
  }
}

export { ImpactStyle, NotificationType }
